import React, { FC } from 'react'
import { Button } from 'antd'
import { NotaryAcknowledgementActionsProps } from './types'

const NotaryAcknowledgementActions: FC<NotaryAcknowledgementActionsProps> = ({
  notaryAcknowledgement,
  submittingAck,
  onSubmit
}) => {
  if (notaryAcknowledgement) return null

  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'center', alignItems: 'center' }}>
      <Button type="primary" loading={submittingAck} onClick={() => onSubmit('will_correct')} size="small">
        I will correct these errors
      </Button>
      <Button loading={submittingAck} onClick={() => onSubmit('request_clarification')} size="small">
        I need clarification on these errors
      </Button>
    </div>
  )
}

export default NotaryAcknowledgementActions
